// Customer Insights
interface MSCIWindow extends Window {
  MSCI?: {
    setUser: (user: { authId: string }) => void;
  };
}

// We keep identifiers like email, zip code, etc. to provide a personalized experience.
export const authenticateUser = (customerIdentifier: string) => {
  const win = window as MSCIWindow;
  if (win?.MSCI) win.MSCI.setUser({ authId: customerIdentifier });
};
